import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const UpdateC = () => {
  const { memberId } = useParams(); // This will be contest_rule id
  const navigate = useNavigate();

  const initialState = {
    id: "",
    SNo: "",
    contest_rule: "",
    units: "",
    points: "",
  };

  const [state, setState] = useState(initialState);

  const { id, SNo, contest_rule, units, points } = state;

  // Fetch contest rule data by id
  const fetchContestRule = () => {
    axios
      .get(`https://lionsdirectoryapi.emedha.in/report/api/contest/${memberId}`)
      .then((resp) => {
        console.log("Fetched Data:", resp.data);
        if (resp.data) {
          setState({
            id: resp.data.id || "",
            SNo: resp.data.SNo || "",
            contest_rule: resp.data.contest_rule || "",
            units: resp.data.units || "",
            points: resp.data.points || "",
          });
        }
      })
      .catch((error) => console.error("Fetch Error:", error));
  };

  useEffect(() => {
    if (memberId) {
      fetchContestRule();
    }
  }, [memberId]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  // Update contest rule API call
  const updateContestRule = async (e) => {
    e.preventDefault();
    console.log("▶️ Form submitted with:", state);

    try {
      const updateRes = await axios.put(
        `https://lionsdirectoryapi.emedha.in/report/api/contest/${id}`,
        {
          SNo,
          contest_rule,
          units,
          points,
        }
      );

      console.log("✅ Contest rule updated:", updateRes.data);
      alert("Contest rule updated successfully!");
      navigate("/contest-rule"); // Redirect or wherever you want
    } catch (error) {
      console.error("❌ Update Error:", error);
      alert("Failed to update contest rule.");
    }
  };

  return (
    <div>
      <h2>Update Contest Rule</h2>
      <form onSubmit={updateContestRule}>
        <input
          type="number"
          name="SNo"
          value={SNo}
          className="form-control"
          placeholder="Serial Number"
          required
          onChange={handleInputChange}
        />
        <br />
        <textarea
          name="contest_rule"
          value={contest_rule}
          className="form-control"
          placeholder="Contest Rule"
          required
          onChange={handleInputChange}
          rows={4}
        />
        <br />
        <input
          type="text"
          name="units"
          value={units || ""}
          className="form-control"
          placeholder="Units"
          onChange={handleInputChange}
        />
        <br />
        <input
          type="number"
          name="points"
          value={points}
          className="form-control"
          placeholder="Points"
          required
          onChange={handleInputChange}
        />
        <br />
        <button type="submit" className="btn btn-danger form-control">
          Update
        </button>
      </form>
    </div>
  );
};

export default UpdateC;
